import { useEffect, useState } from "react";
import {
  CancelLeaveReq,
  HandleLeaveReq,
  ongetOrgLeavePolicies,
  ongetOrgLeaves,
  ongetOrgLeaveTypes,
} from "../services/leave";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { useStateSetter } from "./statehooks/UseStateSettersHook";

import { toast } from "react-toastify";

export default () => {
  const { setLoading } = useStateSetter();
  const { config, SelectedOrg } = useStateGetter();
  const [OrgLeaveReq, setOrgLeaveReq] = useState<any[]>([]);
  const [OrgLeaveTypes, setOrgLeaveTypes] = useState<any[]>([]);
  const [OrgLeavePolicies, setOrgLeavePolicy] = useState([]);
  const {setShowModal} =useStateSetter()
  const addLeaveType = async () => {};

  const getOrgLeaveTypes = async () => {
    setLoading(true);

    try {
      var res = await ongetOrgLeaveTypes(SelectedOrg.id, config);
      setOrgLeaveTypes(res.data);
    } catch (e: any) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const ApproveLeave = async (id: any) => {
    let postdata = {
      leaveID: id, // Required: ID of the leave request to be handled
      status: "approved", // Required: Status of the leave request (either 'approved' or 'rejected')
      actionedComment: "Leave approved.", // Optional: Comment regarding the action taken on the leave
    };
    setLoading(true);

    try {
      var res = await HandleLeaveReq(postdata, config);

      toast.success("Leave Request Approved");
    } catch (e: any) {
      console.log(e);
    } finally {
      setLoading(false);
      getOrgLeaves();
      setShowModal(false)

    }
  };
  const RejectLeave = async (id: any, reason:string) => {
    let postdata = {
      leaveID: id, // Required: ID of the leave request to be handled
      status: "rejected", // Required: Status of the leave request (either 'approved' or 'rejected')
      actionedComment: reason, // Optional: Comment regarding the action taken on the leave
    };
    setLoading(true);

    try {
      var res = await HandleLeaveReq(postdata, config);

      toast.success("Leave Request Rejected");
    } catch (e: any) {
      console.log(e);
    } finally {
      setLoading(false);
      setShowModal(false)

    }
  };
  const CancelLeave = async (id: any) => {
    let postdata = {
      leaveID: id, // Required: ID of the leave request to be canceled
          };
    setLoading(true);

    try {
      var res = await CancelLeaveReq(postdata, config);

      toast.success("Leave Request Canceled");
    } catch (e: any) {
      console.log(e);
      toast.error(e)
    } finally {
      setLoading(false);
      getOrgLeaves();
      setShowModal(false)


    }
  };
  const getOrgLeavePolicies = async () => {
    setLoading(true);

    try {
      var res = await ongetOrgLeavePolicies(SelectedOrg.id, config);
      setOrgLeavePolicy(res.data);
    } catch (e: any) {
      console.log(e);
    } finally {
      setLoading(false);
 
    }
  };
  const getOrgLeaves = async () => {
    setLoading(true);

    try {
      var res = await ongetOrgLeaves(SelectedOrg.id, config);
      setOrgLeaveReq(res.data);
    } catch (e: any) {
      console.log(e);
    } finally {
      setLoading(false);
 

    }
  };

  useEffect(() => {
    getOrgLeaveTypes();
    getOrgLeavePolicies();
    getOrgLeaves();
  }, []);
  const DeleteLeaveType = async () => {};

  return {
    getOrgLeaveTypes,
    OrgLeaveReq,
    setOrgLeaveReq,
    RejectLeave,
    CancelLeave,
    ApproveLeave,
    DeleteLeaveType,
    getOrgLeavePolicies,
    OrgLeavePolicies,
    OrgLeaveTypes,
    addLeaveType,
  };
};
